import React from 'react';
import {Link} from 'react-router-dom';

const EditLink = ({children, disabled, id}) => (
    disabled ?
        <a className="disabled">{children}</a> :
        <Link to={`/surveys/${id}/edit`}>{children}</Link>
);

export default EditLink;
